/* ============================================================
   Holy Ice — capa de conversión (encargo 30-10-2026)
   1. Guía de tallas: pestañas Cadenas / Pulseras / Anillos. Al ABRIR la guía se activa la
      categoría del producto (y en cadena/pulsera, la de la variante elegida). No abre nada
      ni mueve el scroll al cargar la página.
   2. «Abrir la guía de tallas» desde los acordeones reutiliza el botón real del tema.
   3. «Combina con esta pieza»: al cambiar de variante del principal se recalcula qué
      tarjetas cumplen precio <= variante elegida y qué variante ofrece cada una.
   ============================================================ */
(function () {
	"use strict";

	if (!document.body.classList.contains("template-product")) return;

	var form = document.querySelector('form[action*="/cart/add"]');

	function selectedVariantText() {
		if (!form) return "";
		var parts = [];
		form.querySelectorAll("input[type=radio]:checked, select").forEach(function (el) {
			parts.push(el.value || "");
		});
		return parts.join(" ").toLowerCase();
	}

	/* ---------- 1. Pestañas de la guía ---------- */
	function selectTab(root, key, focus) {
		var tabs = root.querySelectorAll("[data-hsg-tab]");
		if (!root.querySelector('[data-hsg-tab="' + key + '"]')) key = "cadena";
		tabs.forEach(function (tab) {
			var on = tab.getAttribute("data-hsg-tab") === key;
			tab.setAttribute("aria-selected", on ? "true" : "false");
			tab.tabIndex = on ? 0 : -1;
			if (on && focus) tab.focus();
		});
		root.querySelectorAll("[data-hsg-panel]").forEach(function (panel) {
			panel.hidden = panel.getAttribute("data-hsg-panel") !== key;
		});
	}

	function kindFor(root) {
		var kind = root.getAttribute("data-kind");
		if (kind === "cadena-pulsera") return /pulsera/.test(selectedVariantText()) ? "pulsera" : "cadena";
		if (kind === "otro") return root.getAttribute("data-hsg-last") || "cadena";
		return kind;
	}

	function initGuides() {
		document.querySelectorAll("[data-hsg]").forEach(function (root) {
			if (root.dataset.hsgReady) return;
			root.dataset.hsgReady = "1";
			selectTab(root, kindFor(root), false);
			root.addEventListener("click", function (e) {
				var tab = e.target.closest("[data-hsg-tab]");
				if (!tab) return;
				root.setAttribute("data-hsg-last", tab.getAttribute("data-hsg-tab"));
				selectTab(root, tab.getAttribute("data-hsg-tab"), false);
			});
			root.addEventListener("keydown", function (e) {
				var tab = e.target.closest("[data-hsg-tab]");
				if (!tab || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
				var list = Array.prototype.slice.call(root.querySelectorAll("[data-hsg-tab]"));
				var i = list.indexOf(tab) + (e.key === "ArrowRight" ? 1 : -1);
				var next = list[(i + list.length) % list.length];
				selectTab(root, next.getAttribute("data-hsg-tab"), true);
				e.preventDefault();
			});
		});
	}

	// Contexto al abrir: se aplica justo cuando el cliente pulsa el botón de la guía.
	document.addEventListener(
		"click",
		function (e) {
			var opener = e.target.closest('[data-js-toggle^="productSizeGuideDrawer"]');
			if (!opener || opener.closest(".popup")) return;
			var popup = document.getElementById(opener.getAttribute("data-js-toggle"));
			var root = popup && popup.querySelector("[data-hsg]");
			if (root) selectTab(root, kindFor(root), false);
		},
		true
	);

	/* ---------- 2. Botón de guía en los acordeones ---------- */
	function initGuideButtons() {
		var real = document.querySelector('.product-options__size-guide [data-js-toggle^="productSizeGuideDrawer"]');
		document.querySelectorAll("[data-open-size-guide]").forEach(function (btn) {
			if (!real) {
				btn.hidden = true;
				return;
			}
			if (btn.dataset.ready) return;
			btn.dataset.ready = "1";
			btn.addEventListener("click", function () {
				real.click();
			});
		});
	}

	/* ---------- 3. Combina con esta pieza ---------- */
	function metalOf(text) {
		var t = String(text).toLowerCase();
		if (/rosa|rose/.test(t)) return "rosa";
		if (/blanc|white|plata|plate|silver|925/.test(t)) return "blanco";
		if (/oro|gold|18k|amarill/.test(t)) return "amarillo";
		return "";
	}

	function readJSON(el) {
		try {
			return JSON.parse(el.textContent);
		} catch (e) {
			return null;
		}
	}

	function syncPairs() {
		var section = document.querySelector("[data-pairs]");
		if (!section || !form) return;
		var idInput = form.querySelector('[name="id"]');
		var mainVariants = readJSON(section.querySelector("[data-main-variants]")) || [];
		var current = null;
		mainVariants.forEach(function (v) {
			if (idInput && String(v.id) === String(idInput.value)) current = v;
		});
		if (!current) return;
		var limit = current.price;
		var metal = metalOf(current.title);
		var max = parseInt(section.getAttribute("data-max"), 10) || 4;
		var shown = 0;

		section.querySelectorAll("[data-pair]").forEach(function (card) {
			var variants = readJSON(card.querySelector("[data-pair-variants]")) || [];
			var ok = variants.filter(function (v) {
				return v.available && v.price <= limit;
			});
			var pick = null;
			if (metal) {
				ok.forEach(function (v) {
					if (!pick && metalOf(v.title) === metal) pick = v;
				});
			}
			pick = pick || ok[0];
			if (!pick || shown >= max) {
				card.hidden = true;
				return;
			}
			shown += 1;
			card.hidden = false;
			card.querySelector("[data-pair-price]").textContent = pick.money;
			card.querySelector("[data-pair-variant]").textContent = pick.title === "Default Title" ? "" : pick.title;
			card.querySelector("[data-pair-link]").setAttribute("href", pick.url);
		});
		section.hidden = shown === 0;
	}

	function onVariantMaybeChanged() {
		// El tema actualiza el input oculto tras su propio manejador de "change".
		window.setTimeout(syncPairs, 80);
	}

	function init() {
		initGuides();
		initGuideButtons();
		syncPairs();
	}

	if (form) form.addEventListener("change", onVariantMaybeChanged);
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
	document.addEventListener("shopify:section:load", init);
})();
